<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <ManagerSidebar :toggler.sync="isToggled" />
      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar
        @toggled="toggleSidebarNav"
        :profile="getManagerUserProfile"
        :showModalJob="visModal"
      />

      <ManagerJobsList @modal="showTheModal($event)" />
    </div>

    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import ManagerSidebar from '@/components/Navigations/ManagerSidebar';
import TopNavbar from '@/components/Navigations/TopNavbar';
import ManagerJobsList from '@/components/Manager/Jobs/ManagerJobsList';
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';

import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    ManagerSidebar,
    TopNavbar,
    ManagerJobsList,
  },
  mixins: [toggleSidebarNav],
  data: () => ({
    isToggled: false,
    visModal: '',
  }),
  methods: {
    ...mapActions('managerStoreModule', ['retrieveManagerProfile', 'retrieveManagerUserProfile']),
    showTheModal(e) {
      this.visModal = e;
    },
  },
  computed: { ...mapGetters('managerStoreModule', ['getManagerProfile', 'getManagerUserProfile']) },
  mounted() {
    this.retrieveManagerProfile();
    this.retrieveManagerUserProfile().then(() => {
      if (sessionStorage.getItem('first') !== '1') {
        this.$toasted.success(`Welcome back, ${this.getManagerUserProfile.first_name}!`, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      }
      sessionStorage.setItem('first', '1');
    });
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';

/* #activities,
#emails {
  h6 {
    font-size: 18px;
    font-family: $font-family-sans-serif;
  }

  .activities-media li {
    border-radius: 0 !important;
    border: 0;
    padding-right: 70px;
  }

  .activities-media li:nth-child(odd) {
    border-left: 5px solid #f05a00;
    background-color: #f1f1f3;
  }

  .activities-media li:nth-child(even) {
    border-left: 5px solid #747674;
  }

  .activities-name {
    font-family: Lato;
    color: $color-base-blue;
    letter-spacing: 0.9px;
    margin: 0;
  }

  .activities-status-color {
    color: #f05a00;
  }
} */
</style>
